import { useEffect, useState } from "react";
import Modal from "react-modal";
import api from "../../services/api";
import ReactLoading from "react-loading";
import "./index.css";
import { usePluginspace } from "../../hooks/usePluginspace";
import { floatToPrice } from "../../functions/price_functions";
import { MainButton } from "../MainButton";
import { ProductType } from "../../contexts/OrderContext";
import { useOrder } from "../../hooks/useOrder";
import Swal from "sweetalert2";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import EmptyCartImg from "../../assets/images/empty-cart.svg";
import { useFoodConfig } from "../../hooks/useFood";
import { useToast } from "../../hooks/useToast";
import { useAppConfig } from "../../hooks/useAppConfig";

type ModalResumeProps = {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  tableNumber: number;
  cardNumber: number;
  paymentTable: boolean;
  paymentCard: boolean;
  webappbutton: string;
  fontbutton: string;
};

type AdditionalResponseType = {
  Produto: {
    Codigo: string;
    Descricao: string;
    PrecoVenda: number;
  };
  Quantidade: number;
};

type AdditionalType = {
  code: string;
  name: string;
  price: number;
  quantity: number;
};

type ItemType = {
  id: number;
  code: string;
  name: string;
  quantity: number;
  price: number;
  additionals: AdditionalType[];
  promotionalPrice: number;
  stock: number;
  image: string;
  type: string;
  typeFractional: string;
  orderId: number;
};

type FractionResponseType = {
  Produto: {
    PrecoVenda: number;
    PrecoVendaAMaiorFracionado: number;
    Descricao: string;
  };
  Quantidade: number;
  ValorTotal: number;
};

export function ModalResume({
  isOpen,
  setIsOpen,
  tableNumber,
  cardNumber,
  paymentTable,
  paymentCard,
  fontbutton,
  webappbutton,
}: ModalResumeProps) {
  const navigate = useNavigate();
  const { getToken, getLocations } = usePluginspace();
  const {
    setProductsOrder,
    setType,
    setOrderAddress,
    setLocationId,
    setServiceTaxes,
    clearOrder,
  } = useOrder();
  const { pluginspace_id } = useParams();
  const { config } = useAppConfig();
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState<ItemType[]>([]);
  const [valSubTotal, setValSubTotal] = useState(0);
  const [valService, setValService] = useState(0);
  const [valTotal, setValTotal] = useState(0);
  const [closed, setClosed] = useState(false);

  const { verifyToOrder, isTable } = useFoodConfig();
  const foodCondig = useFoodConfig();
  const location = useLocation();
  const toastComponent = useToast();

  useEffect(() => {
    if (tableNumber && !cardNumber) {
      getResumeTable();
    } else if (cardNumber) {
      getResumeCard();
    }
  }, []);

  const getResumeCard = async () => {
    setLoading(true);
    await api
      .post(
        "/api/order-food/card-movement",
        {
          cardNumber,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        if (response.data && response.data.dados && response.data.dados.Itens) {
          if (response.data.dados.StatusCartao === 3) {
            localStorage.removeItem("reload_app_food");
            localStorage.removeItem("first_access");
            setClosed(true);
          }
          let _items: ItemType[] = [];
          response.data.dados.Itens.map((item: any, index: number) => {
            let _itemIndex = _items.findIndex(
              (c) => item.Produto && c.code === item.Produto.Codigo
            );
            if (
              _itemIndex === -1 ||
              (item.ItensAdicionais && item.ItensAdicionais.length > 0)
            ) {
              if (item.Produto) {
                let priceTemp = item.Produto.PrecoVenda;
                /*
                if(item.ItensAdicionais && item.ItensAdicionais.length > 0){
                  item.ItensAdicionais.forEach((additional: AdditionalResponseType) => {
                    priceTemp += (additional.Produto.PrecoVenda * additional.Quantidade)
                  })
                }*/
                _items.push({
                  id: item.Produto ? item.Produto.id : index,
                  code: item.Produto ? item.Produto.Codigo : "",
                  name: item.Produto ? item.Produto.Descricao : "",
                  quantity: item.Quantidade,
                  price: priceTemp,
                  promotionalPrice: item.Produto
                    ? item.Produto.PrecoPromocional
                    : "",
                  stock: item.Produto ? item.Produto.QuantidadeEstoque : "",
                  type: item.Produto ? item.Produto.type : "",
                  typeFractional: item.Produto
                    ? item.Produto.typeFractional
                    : "",
                  image: item.Produto ? item.Produto.image : "",
                  orderId: item.orderId,
                  additionals:
                    item.ItensAdicionais && item.ItensAdicionais.length > 0
                      ? item.ItensAdicionais.map(
                          (additional: AdditionalResponseType) => ({
                            code: additional.Produto.Codigo,
                            name: additional.Produto.Descricao,
                            price: additional.Produto.PrecoVenda,
                            quantity: additional.Quantidade,
                          })
                        )
                      : [],
                });
              } else {
                if (item.ItensFracao && item.ItensFracao.length > 0) {
                  let name = "";
                  let price = 0;
                  let quantity = 0;

                  item.ItensFracao.forEach(
                    (fraction: FractionResponseType, index: number) => {
                      let sameName = false;
                      item.ItensFracao.forEach(
                        (
                          itemFract: FractionResponseType,
                          indexFract: number
                        ) => {
                          if (
                            itemFract.Produto.Descricao ===
                              fraction.Produto.Descricao &&
                            index < indexFract
                          ) {
                            sameName = true;
                          }
                        }
                      );
                      if (!sameName) {
                        name +=
                          fraction.Produto.Descricao +
                          (index === item.ItensFracao.length - 1 ? "" : " | ");
                      }
                      price += fraction.ValorTotal;
                      quantity += fraction.Quantidade;
                    }
                  );
                  _items.push({
                    id: item.Produto ? item.Produto.id : index,
                    code: item.Produto ? item.Produto.Codigo : "",
                    name,
                    quantity,
                    price,
                    promotionalPrice: 0,
                    stock: item.Produto ? item.Produto.QuantidadeEstoque : "",
                    type: item.Produto ? item.Produto.type : "",
                    typeFractional: item.Produto
                      ? item.Produto.typeFractional
                      : "",
                    image: item.Produto ? item.Produto.image : "",
                    orderId: item.orderId,
                    additionals: [],
                  });
                }
              }
            } else {
              _items[_itemIndex].quantity += item.Quantidade;
            }
          });
          setItems(_items);
        }
        if (
          response.data &&
          response.data.dados &&
          response.data.dados.Totais
        ) {
          setValSubTotal(response.data.dados.Totais.Subtotal ?? 0);
          setValService(response.data.dados.Totais.Servico ?? 0);
          setValTotal(response.data.dados.Totais.TotalConta ?? 0);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const getResumeTable = async () => {
    setLoading(true);
    await api
      .post(
        "/api/order-food/table-movement",
        {
          tableNumber,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        if (response.data && response.data.dados && response.data.dados.Itens) {
          if (response.data.dados.StatusMesa === 3) {
            localStorage.removeItem("reload_app_food");
            localStorage.removeItem("first_access");
            setClosed(true);
          }
          let _items: ItemType[] = [];
          response.data.dados.Itens.map((item: any, index: number) => {
            let _itemIndex = _items.findIndex(
              (c) => item.Produto && c.code === item.Produto.Codigo
            );
            if (
              _itemIndex === -1 ||
              (item.ItensAdicionais && item.ItensAdicionais.length > 0)
            ) {
              if (item.Produto) {
                let priceTemp = item.Produto.PrecoVenda;
                if (item.ItensAdicionais && item.ItensAdicionais.length > 0) {
                  item.ItensAdicionais.forEach(
                    (additional: AdditionalResponseType) => {
                      priceTemp +=
                        additional.Produto.PrecoVenda * additional.Quantidade;
                    }
                  );
                }
                _items.push({
                  id: item.Produto ? item.Produto.id : index,
                  code: item.Produto ? item.Produto.Codigo : "",
                  name: item.Produto ? item.Produto.Descricao : "",
                  quantity: item.Quantidade,
                  price: priceTemp,
                  promotionalPrice: item.Produto
                    ? item.Produto.PrecoPromocional
                    : "",
                  stock: item.Produto ? item.Produto.QuantidadeEstoque : "",
                  type: item.Produto ? item.Produto.type : "",
                  typeFractional: item.Produto
                    ? item.Produto.typeFractional
                    : "",
                  image: item.Produto ? item.Produto.image : "",
                  orderId: item.orderId,
                  additionals:
                    item.ItensAdicionais && item.ItensAdicionais.length > 0
                      ? item.ItensAdicionais.map(
                          (additional: AdditionalResponseType) => ({
                            code: additional.Produto.Codigo,
                            name: additional.Produto.Descricao,
                            price: additional.Produto.PrecoVenda,
                            quantity: additional.Quantidade,
                          })
                        )
                      : [],
                });
              } else {
                if (item.ItensFracao && item.ItensFracao.length > 0) {
                  let name = "";
                  let price = 0;
                  let quantity = 0;

                  item.ItensFracao.forEach(
                    (fraction: FractionResponseType, index: number) => {
                      let sameName = false;
                      item.ItensFracao.forEach(
                        (
                          itemFract: FractionResponseType,
                          indexFract: number
                        ) => {
                          if (
                            itemFract.Produto.Descricao ===
                              fraction.Produto.Descricao &&
                            index < indexFract
                          ) {
                            sameName = true;
                          }
                        }
                      );
                      if (!sameName) {
                        name +=
                          fraction.Produto.Descricao +
                          (index === item.ItensFracao.length - 1 ? "" : " | ");
                      }
                      price += fraction.ValorTotal;
                      quantity += fraction.Quantidade;
                    }
                  );
                  _items.push({
                    id: item.Produto ? item.Produto.id : index,
                    code: item.Produto ? item.Produto.Codigo : "",
                    name,
                    quantity,
                    price,
                    promotionalPrice: 0,
                    stock: item.Produto ? item.Produto.QuantidadeEstoque : "",
                    type: item.Produto ? item.Produto.type : "",
                    typeFractional: item.Produto
                      ? item.Produto.typeFractional
                      : "",
                    image: item.Produto ? item.Produto.image : "",
                    orderId: item.orderId,
                    additionals: [],
                  });
                }
              }
            } else {
              _items[_itemIndex].quantity += item.Quantidade;
            }
          });
          setItems(_items);
        }
        if (
          response.data &&
          response.data.dados &&
          response.data.dados.Totais
        ) {
          setValSubTotal(response.data.dados.Totais.Subtotal ?? 0);
          setValService(response.data.dados.Totais.Servico ?? 0);
          setValTotal(response.data.dados.Totais.TotalConta ?? 0);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  async function sendOrder() {
    try {
      if (isTable) {
        await sendTable();
      } else {
        await sendCard();
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function clearDeviceAndNavigate(pluginspace_id: string) {
    clearOrder();

    localStorage.removeItem("reload_app_food");
    navigate(`/${pluginspace_id}?kicked=true`, { replace: true });
  }

  const sendTable = async () => {
    const pluginspace_id = location.pathname.split("/")[1];

    if (config?.content.pdv.safeMode) {
      const isValid = await verifyToOrder();

      if (!isValid || !isValid.success) {
        clearDeviceAndNavigate(pluginspace_id);
      }

      const status = isValid.data.status;

      let title;
      let text;

      switch (status) {
        case "closed":
          if (isTable) {
            title = "Mesa Fechada";
            text =
              "Para fazer pedidos, solicite ao garçom que reabra a sua conta.";
          } else {
            title = "Comanda fechada";
            text =
              "Para fazer pedidos, solicite ao garçom que reabra a sua conta.";
          }
          setIsOpen(false);
          Swal.fire({
            icon: "info",
            title: title,
            text: text,
            confirmButtonText: "Ok",
          });
          return;
        case "payed":
          if (isTable) {
            title = "Mesa Paga";
            text =
              "Para fazer pedidos, leia novamente o Qrcode para fazer seus pedidos.";
          } else {
            title = "Comanda Paga";
            text =
              "Para fazer pedidos, leia novamente o Qrcode para fazer seus pedidos.";
          }

          setIsOpen(false);
          Swal.fire({
            icon: "info",
            title: title,
            text: text,
            confirmButtonText: "Ok",
          }).then(() => clearDeviceAndNavigate(pluginspace_id));
          return;
        case "removed":
          if (isTable) {
            title = "Acesso indisponível";
            text =
              "Essa mesa não está mais disponível, leia novamente o Qrcode para fazer seus pedidos.";
          } else {
            title = "Comanda indisponível";
            text =
              " Essa comanda não está mais disponível, solicite outra para fazer seus pedidos.";
          }
          setIsOpen(false);
          Swal.fire({
            icon: "info",
            title: title,
            text: text,
            confirmButtonText: "Ok",
          }).then(() => clearDeviceAndNavigate(pluginspace_id));
          return;
        case "active":
          // Add logic for 'active' status here
          break;
        default:
          // Handle unexpected status here
          break;
      }
    }

    if (paymentTable || paymentCard) {
      const table = localStorage.getItem("table_number");
      const products: ProductType[] = items.map((item) => {
        return {
          id: item.id,
          name: item.name,
          image: item.image,
          code: item.code,
          additionals: item.additionals,
          locationId: 0,
          pluginspaceHash: pluginspace_id ? pluginspace_id : "",
          promotionalPrice: item.promotionalPrice,
          quantity: item.quantity,
          sku: item.code,
          stock: item.stock,
          type: item.type,
          typeFractional: item.typeFractional,
          unitPrice: item.price,
          variation: [],
          table: table ? parseInt(window.atob(table)) : 0,
          orderId: item.orderId,
          outStock: false,
          measures: null,
        };
      });
      setServiceTaxes(valService);
      setProductsOrder(products);
      setLoading(true);
      const locations = await getLocations();
      const locationStore = locations.find((loc) => loc.type === "address");
      const locationTable = locations.find(
        (loc) => loc.type === "internal" && loc.code === "mesa"
      );
      if (locationStore && locationTable) {
        setLoading(false);
        setType("table");

        setOrderAddress({
          address: locationStore.address ? locationStore.address.street : "",
          cep: locationStore.cep,
          state: locationStore.address ? locationStore.address.state : "",
          city: locationStore.address ? locationStore.address.city : "",
          complement: locationStore.address ? locationStore.address.extra : "",
          district: locationStore.address ? locationStore.address.district : "",
          name: locationStore.name,
          number: locationStore.address ? locationStore.address.number : "",
          reference: "",
        });
        setLocationId(locationTable.id);
        navigate(`/${pluginspace_id}/customer`);
      } else {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "Não foi possível encontrar endereço da loja",
        });
      }
    } else {
      Swal.fire({
        title: "Deseja realmente fechar a conta?",
        showDenyButton: true,
        confirmButtonText: "Sim",
        denyButtonText: "Não",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const resultaModalConfirm = await qtdPersonsInTable();

          const qtdPessoas = resultaModalConfirm?.numberOfPeople;
          const retirarServico = resultaModalConfirm?.removeServiceFee;

          if (!qtdPessoas) return;
          if (retirarServico === null) return;
          const table = localStorage.getItem("table_number");
          if (!table) {
            toastComponent.openToast(
              "warning",
              "Não foi possível encontrar sua mesa",
              4000
            );
          }
          if (qtdPessoas && retirarServico !== null) {
            setLoading(true);
            await api
              .post(
                "/api/order-food/close-table",
                {
                  removeService: retirarServico,
                  people: qtdPessoas,
                  table: table ? parseInt(window.atob(table)) : 0,
                },
                {
                  headers: {
                    Authorization: `Bearer ${await getToken()}`,
                  },
                }
              )
              .then(async (response) => {
                setLoading(false);
                if (response.data.success === true) {
                  localStorage.removeItem("reload_app_food");
                  localStorage.removeItem("first_access");
                  toastComponent.openToast(
                    "success",
                    "Fechamento de conta solicitado, aguarde que em breve o garçom trará sua conta",
                    6000
                  );
                  setIsOpen(false);
                } else {
                  toastComponent.openToast(
                    "error",
                    "Não foi possível solicitar o fechamento da conta, por favor, dirija-se ao caixa",
                    6000
                  );
                }
              })
              .catch((err) => {
                console.log(err);
                setLoading(false);
                const errMessage =
                  err &&
                  err.response &&
                  err.response.data &&
                  err.response.data.message
                    ? err.response.data.message
                    : "Falha ao fechar conta";
                Swal.fire({
                  icon: "error",
                  title: "Erro!",
                  text: errMessage,
                });
              });
          }
        } else {
          return;
        }
      });
    }
  };

  const sendCard = async () => {
    try {
      const pluginspace_id = location.pathname.split("/")[1];

      if (config?.content.pdv.safeMode) {
        const isValid = await verifyToOrder();

        if (!isValid || !isValid.success) {
          clearDeviceAndNavigate(pluginspace_id);
        }

        const status = isValid.data.status;

        let title;
        let text;

        switch (status) {
          case "closed":
            if (isTable) {
              title = "Mesa Fechada";
              text =
                "Para fazer pedidos, solicite ao garçom que reabra a sua conta.";
            } else {
              title = "Comanda fechada";
              text =
                "Para fazer pedidos, solicite ao garçom que reabra a sua conta.";
            }
            setIsOpen(false);
            Swal.fire({
              icon: "info",
              title: title,
              text: text,
              confirmButtonText: "Ok",
            });
            return;
          case "payed":
            if (isTable) {
              title = "Mesa Paga";
              text =
                "Para fazer pedidos, leia novamente o Qrcode para fazer seus pedidos.";
            } else {
              title = "Comanda Paga";
              text =
                "Para fazer pedidos, leia novamente o Qrcode para fazer seus pedidos.";
            }

            setIsOpen(false);
            Swal.fire({
              icon: "info",
              title: title,
              text: text,
              confirmButtonText: "Ok",
            }).then(() => clearDeviceAndNavigate(pluginspace_id));
            return;
          case "removed":
            if (isTable) {
              title = "Acesso indisponível";
              text =
                "Essa mesa não está mais disponível, leia novamente o Qrcode para fazer seus pedidos.";
            } else {
              title = "Comanda indisponível";
              text =
                " Essa comanda não está mais disponível, solicite outra para fazer seus pedidos.";
            }
            setIsOpen(false);
            Swal.fire({
              icon: "info",
              title: title,
              text: text,
              confirmButtonText: "Ok",
            }).then(() => clearDeviceAndNavigate(pluginspace_id));
            return;
          case "active":
            // Add logic for 'active' status here
            break;
          default:
            // Handle unexpected status here
            break;
        }
      }

      if (paymentCard) {
        const card = localStorage.getItem("card_number");
        const products: ProductType[] = items.map((item) => {
          return {
            id: item.id,
            name: item.name,
            image: item.image,
            code: item.code,
            additionals: item.additionals,
            locationId: 0,
            pluginspaceHash: pluginspace_id ? pluginspace_id : "",
            promotionalPrice: item.promotionalPrice,
            quantity: item.quantity,
            sku: item.code,
            stock: item.stock,
            type: item.type,
            typeFractional: item.typeFractional,
            unitPrice: item.price,
            variation: [],
            table: card ? parseInt(window.atob(card)) : 0,
            orderId: item.orderId,
            outStock: false,
            measures: null,
          };
        });
        setServiceTaxes(valService);
        setProductsOrder(products);
        setLoading(true);
        const locations = await getLocations();
        const locationStore = locations.find((loc) => loc.type === "address");
        const locationCard = locations.find(
          (loc) => loc.type === "internal" && loc.code === "mesa"
        );
        if (locationStore && locationCard) {
          setLoading(false);
          setType("card");

          setOrderAddress({
            address: locationStore.address ? locationStore.address.street : "",
            cep: locationStore.cep,
            state: locationStore.address ? locationStore.address.state : "",
            city: locationStore.address ? locationStore.address.city : "",
            complement: locationStore.address
              ? locationStore.address.extra
              : "",
            district: locationStore.address
              ? locationStore.address.district
              : "",
            name: locationStore.name,
            number: locationStore.address ? locationStore.address.number : "",
            reference: "",
          });
          setLocationId(locationCard.id);
          navigate(`/${pluginspace_id}/customer`);
        } else {
          setLoading(false);
          Swal.fire({
            icon: "error",
            title: "Erro",
            text: "Não foi possível encontrar endereço da loja",
          });
        }
      } else {
        Swal.fire({
          title: "Deseja realmente fechar a conta?",
          showDenyButton: true,
          confirmButtonText: "Sim",
          denyButtonText: "Não",
        }).then(async (result) => {
          if (result.isConfirmed) {
            const resultaModalConfirm = await qtdPersonsInTable();

            const qtdPessoas = resultaModalConfirm?.numberOfPeople;
            const retirarServico = resultaModalConfirm?.removeServiceFee;

            if (!qtdPessoas) return;
            if (retirarServico === null) return;
            const card = localStorage.getItem("card_number");
            const table = tableNumber ? tableNumber : foodCondig.tableNumber;

            if (!card) {
              toastComponent.openToast(
                "warning",
                "Não foi possível encontrar sua comanda",
                4000
              );
              return;
            }

            if (!table) {
              toastComponent.openToast(
                "warning",
                "Não foi possível encontrar sua mesa",
                4000
              );
              return;
            }

            if (qtdPessoas && retirarServico !== null) {
              setLoading(true);
              await api
                .post(
                  "/api/order-food/close-card",
                  {
                    removeService: retirarServico,
                    people: qtdPessoas,
                    card: card ? parseInt(window.atob(card)) : 0,
                    table: table ? table : 0,
                  },
                  {
                    headers: {
                      Authorization: `Bearer ${await getToken()}`,
                    },
                  }
                )
                .then(async (response) => {
                  setLoading(false);
                  if (response.data.success === true) {
                    localStorage.removeItem("reload_app_food");
                    localStorage.removeItem("first_access");
                    toastComponent.openToast(
                      "success",
                      "Fechamento de conta solicitado, aguarde que em breve o garçom trará sua conta",
                      6000
                    );
                    setIsOpen(false);
                  } else {
                    toastComponent.openToast(
                      "error",
                      "Não foi possível solicitar o fechamento da conta, por favor, dirija-se ao caixa",
                      6000
                    );
                  }
                })
                .catch((err) => {
                  console.log(err);
                  setLoading(false);
                  const errMessage =
                    err &&
                    err.response &&
                    err.response.data &&
                    err.response.data.message
                      ? err.response.data.message
                      : "Falha ao fechar conta";
                  Swal.fire({
                    icon: "error",
                    title: "Erro!",
                    text: errMessage,
                  });
                });
            }
          } else {
            return;
          }
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const removeService = async () => {
    return Swal.fire({
      title: "Deseja retirar a taxa de serviço?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Sim",
      denyButtonText: "Não",
    }).then(async (result) => {
      if (!result.isDismissed) {
        return result.isConfirmed;
      } else {
        return null;
      }
    });
  };

  const qtdPersonsInTable = async () => {
    return Swal.fire({
      title: "Quantas pessoas estão na mesa com você?",
      html: `
      <div class="div_input_modal_swalFire">
        <input id="swal-input1" type="number" class="input_swalFire_number" placeholder="Número de pessoas">
            <div class='div_input_checkox'>
              <input id="swal-input2" type="checkbox">
              <label for="swal-input2">Deseja retirar a taxa de serviço?</label>
            </div>
        </div>
  `,
      focusConfirm: false,
      preConfirm: () => {
        const input1 = document.getElementById(
          "swal-input1"
        ) as HTMLInputElement | null;
        const input2 = document.getElementById(
          "swal-input2"
        ) as HTMLInputElement | null;

        if (input1 && input1.value) {
          if (input1.value.length > 2) {
            Swal.showValidationMessage(
              "Limite máximo de 2 dígitos para o número de pessoas"
            );
            return null;
          }
          return {
            numberOfPeople: input1.value,
            removeServiceFee: input2?.checked || false,
          };
        } else {
          Swal.showValidationMessage("Preencha o número de pessoas");
          return null;
        }
      },
      showCancelButton: true,
      confirmButtonText: "Confirmar",
      showLoaderOnConfirm: true,
    }).then((result) => {
      if (result.isConfirmed) {
        return result.value;
      } else {
        return {
          numberOfPeople: 0,
          removeServiceFee: false,
        };
      }
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => setIsOpen(false)}
      className="modal-resume"
      contentLabel="Meus pedidos"
      overlayClassName="overlay-modal"
      ariaHideApp={false}
    >
      <div className="modal-resume-content">
        <div className="modal-resume-body">
          <div className="title">
            <svg
              onClick={() => setIsOpen(false)}
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.978551 2.97126L6.957 8.94971L0.978551 14.9282L2.97137 16.921L8.94981 10.9425L14.9283 16.921L16.9211 14.9282L10.9426 8.94971L16.9211 2.97126L14.9283 0.978446L8.94981 6.95689L2.97137 0.978446L0.978551 2.97126Z"
                fill="#636363"
              />
            </svg>
          </div>

          {loading ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <ReactLoading
                type="spinningBubbles"
                color="#636363"
                height={40}
                width={40}
              />
            </div>
          ) : items.length > 0 ? (
            <>
              <div className="items">
                {items.map((item, i) => (
                  <div key={`item=${i}`} className="mt-2">
                    {item.code !== "" && (
                      <div>
                        <p>{item.code}</p>
                      </div>
                    )}
                    <div style={{ flex: 1 }}>
                      <div className="d-flex flex-column">
                        <p>{item.name}</p>
                        {item.additionals.map((add) => (
                          <p>{`${add.quantity}X ${add.name} (${floatToPrice(
                            add.price
                          )})`}</p>
                        ))}
                      </div>
                    </div>
                    <div>
                      <p>{`${item.quantity}x`}</p>
                    </div>
                    <div style={{ width: "20%", textAlign: "right" }}>
                      <p>{floatToPrice(item.price)}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div className="totals">
                <div>
                  <div style={{ flex: 1, textAlign: "right" }}>
                    <p>Subtotal</p>
                  </div>
                  <div style={{ width: "20%", textAlign: "right" }}>
                    <p>{floatToPrice(valSubTotal)}</p>
                  </div>
                </div>
                <div>
                  <div style={{ flex: 1, textAlign: "right" }}>
                    <p>Serviço</p>
                  </div>
                  <div style={{ width: "20%", textAlign: "right" }}>
                    <p>{floatToPrice(valService)}</p>
                  </div>
                </div>
                <div>
                  <div style={{ flex: 1, textAlign: "right" }}>
                    <p>Total</p>
                  </div>
                  <div style={{ width: "20%", textAlign: "right" }}>
                    <p>{floatToPrice(valTotal)}</p>
                  </div>
                </div>
              </div>
              {items.length > 0 &&
              !closed &&
              !config?.content.pdv.closeAccountButton ? (
                <div className="button_modal_conta">
                  <MainButton
                    color={fontbutton}
                    backgroundColor={webappbutton}
                    text={
                      (paymentTable && tableNumber) ||
                      (paymentCard && cardNumber)
                        ? "Efetuar Pagamento"
                        : "Fechar Conta"
                    }
                    onClick={sendOrder}
                  />
                </div>
              ) : (
                <>
                  {!config?.content.pdv.closeAccountButton && closed ? (
                    <>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <p
                          style={{
                            color: "red",
                            textAlign: "center",
                            fontSize: "13px",
                          }}
                        >
                          Fechamento de conta solicitado, aguarde que em breve o
                          garçom trará sua conta.
                        </p>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </>
              )}
            </>
          ) : (
            <div className="empty-items">
              <div className="image">
                <img src={EmptyCartImg} alt="Carrinho vazio" />
              </div>
              <div className="text">
                <p>
                  Não existe consumação em sua{" "}
                  {!cardNumber ? "mesa" : "comanda"}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
}
